import GroupsIcon from '@mui/icons-material/Groups'
import { Box, Chip, IconButton, Tooltip } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Contact, DensityStyleTypes } from 'types'

interface AdditionalContactsProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const AdditionalContactsCell: FC<AdditionalContactsProps> = ({ params, densityStyles }) => {
  const { row } = params
  const relatedContacts = row?.relatedContacts ?? []
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      {relatedContacts && relatedContacts.length > 0 ? (
        <Tooltip
          title={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {relatedContacts.map((contact: Contact) => (
                <Link
                  key={contact.contacts_uuid}
                  to={`/contacts/${contact.id || contact.contacts_uuid}/details`}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <Chip
                    label={contact.name}
                    variant="outlined"
                    sx={{
                      margin: '5px',
                      width: '150px',
                      minWidth: '150px',
                    }}
                  />
                </Link>
              ))}
            </Box>
          }
          placement="top"
          arrow
          PopperProps={{
            modifiers: [{ name: 'preventOverflow', options: { padding: 8 } }],
          }}
          sx={{
            '& .MuiTooltip-tooltip': {
              maxWidth: 'none',
              minWidth: '200px',
              backgroundColor: 'rgba(97,97,97,0.9)',
            },
            '& .MuiTooltip-arrow': { color: 'rgba(97,97,97,0.9)' },
          }}
        >
          <IconButton size="small">
            <GroupsIcon sx={{ height: densityStyles.iconSize + 3, width: densityStyles.iconSize + 3 }} />
          </IconButton>
        </Tooltip>
      ) : (
        <GroupsIcon
          sx={{
            height: densityStyles.iconSize + 3,
            width: densityStyles.iconSize + 3,
            color: 'text.disabled',
            opacity: 0.3,
          }}
        />
      )}
    </Box>
  )
}
export default AdditionalContactsCell
